module.exports = __webpack_public_path__ + "img/yuanjie-logo1.8f967750.png";